import { axios } from "@/lib/axios";
import { MutationConfig } from "@/lib/react-query";
import { useSnackbar } from "notistack";
import { useMutation, useQueryClient } from "react-query";

type DeleteUserAuthorizationDTO = {
  activityId: number;
  processId: number | undefined;
  userId: number | undefined;
};

const deleteUserAuthorization = async ({
  userId,
  processId,
  activityId,
}: DeleteUserAuthorizationDTO): Promise<void> => {
  if (!userId || !processId) {
    return Promise.reject();
  }
  return await axios.delete(
    `/authorization/${processId}/users/${userId}/activities/${activityId}`
  );
};

type UseDeleteUserAuthorizationOptions = {
  processId: number | undefined;
  userId: number | undefined;
  config?: MutationConfig<typeof deleteUserAuthorization>;
};

export const useDeleteUserAuthorization = ({
  config,
  userId,
  processId,
}: UseDeleteUserAuthorizationOptions) => {
  const { enqueueSnackbar } = useSnackbar();

  const queryClient = useQueryClient();

  return useMutation({
    onError: (error) => {
      const message = error.response?.data?.message || error.message;
      enqueueSnackbar(message, { variant: "error" });
    },
    onSettled: () => {
      return queryClient.invalidateQueries([
        "authorization",
        processId,
        "users",
        userId,
      ]);
    },
    ...config,
    mutationFn: deleteUserAuthorization,
  });
};
